import React from 'react';

import { isEqual } from 'lodash';

import { siteIds } from '../../../constants';
import { siteId } from '../../../sites';

import ViinimaaAgeVerification from './viinimaa';

function AgeVerification(props) {
  if (isEqual(siteId, siteIds.Viinimaa)) {
    return <ViinimaaAgeVerification {...props} />;
  }
  if (isEqual(siteId, siteIds.Folkofolk)) {
    return (
      <ViinimaaAgeVerification
        logo="https://res.cloudinary.com/anora/image/upload/folkofolk%2Flogos%2Ffof-logo-white.svg"
        {...props}
      />
    );
  }
  return null;
}

export default AgeVerification;
